// Friendly labels for A-Level Environmental Science content groups and topic codes.
// Topic codes are the first three dot-separated parts of an AQA spec_ref
// (e.g. "3.1.2" from "3.1.2.3.5"), matching the `topic` field computed in
// src/data/questions.js for the envSciQuestions export.
// Labels come from the AQA spec topic_label / section values in
// spec-statements.json. Content groups are the first two parts of the spec_ref
// (e.g. "3.1") and align with the AQA spec sections.

// Two-part code → friendly group label. Only groups that actually have
// questions in the bank are listed; if more are added later, extend this map.
export const ENV_SCI_CONTENT_GROUPS = {
  '3.1': 'Living Environment',
  '3.5': 'Biological Resources',
  '3.6': 'Sustainability',
  '3.7': 'Research Methods',
};

export function envSciTopicToGroup(topic) {
  if (!topic) return null;
  return topic.split('.').slice(0, 2).join('.');
}

export function envSciGroupLabel(code) {
  return ENV_SCI_CONTENT_GROUPS[code] ?? code;
}

// Fine-grained 3-part topic labels (retained for reference and any future
// per-topic UI; the Topic Mock picker uses the content groups above).
export const ENV_SCI_TOPIC_LABELS = {
  '3.1.1': 'Conditions for Life on Earth',
  '3.1.2': 'Conservation of Biodiversity',
  '3.1.3': 'Life Processes & Conservation Planning',
  '3.2.1': 'The Atmosphere',
  '3.2.2': 'The Hydrosphere',
  '3.2.3': 'Mineral Resources',
  '3.2.4': 'Biogeochemical Cycles',
  '3.2.5': 'Soils',
  '3.3.1': 'Energy & the Development of Society',
  '3.3.2': 'Features of Energy Resources',
  '3.3.3': 'Sustainability of Energy Resources',
  '3.3.4': 'Future Energy Supplies',
  '3.4.1': 'Properties of Pollutants',
  '3.4.2': 'Environment & Severity of Pollution',
  '3.4.3': 'Strategies to Control Pollutants',
  '3.5.1': 'Agriculture',
  '3.5.2': 'Aquatic Food Production',
  '3.5.3': 'Forest Resources',
  '3.6.1': 'Dynamic Equilibria',
  '3.6.2': 'Energy (Research Methods)',
  '3.6.3': 'Material Cycles',
  '3.6.4': 'The Circular Economy',
  '3.7.1': 'Scientific Methodologies',
  '3.7.2': 'Sampling Techniques',
};

export function envSciTopicLabel(code) {
  return ENV_SCI_TOPIC_LABELS[code] ?? code;
}
